import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { QuestionBank } from '../types/question-bank.type';

export type DeleteQuestionBankPayload = {
  question_bank_id: string;
};
export type DeleteQuestionBankResponse = ApiResponse<QuestionBank>;

export const deleteQuestionBank = async (
  payload: DeleteQuestionBankPayload
): Promise<DeleteQuestionBankResponse> => {
  const { question_bank_id } = payload;
  const url = `question-bank/${question_bank_id}`;

  return await apiClient.delete(url);
};

export function deleteQuestionBankMutationOptions() {
  return mutationOptions<
    DeleteQuestionBankResponse,
    AxiosError,
    DeleteQuestionBankPayload
  >({
    mutationFn: deleteQuestionBank,
  });
}
